import { useCallback } from 'react'

import { api } from 'app/api'
import {
  GET_GENERATE_FILE,
  convertParams as convertParamsGenerate,
  convertResult as convertResultGenerate,
} from 'app/common/api/requests/reports/generate_file/get'
import {
  GET_DOWNLOAD_FILE,
  convertParams as convertParamsDownload,
} from 'app/common/api/requests/reports/download_file/get'

import { ReportFileFormat } from 'app/common/types/reports/generateFile'


type Handlers = {
  getGenerateFile: (reportID: string) => Promise<string | null>,
  onFileDownload: (reportID: string) => Promise<boolean | null>,
}

interface Options {
  filename: string,
  fileFormat: ReportFileFormat
}

export function useGenerateFile({ filename, fileFormat = ReportFileFormat.XLSX }: Options): Handlers {
  const getGenerateFile = useCallback(async (reportID: string) => {
    if (!reportID) return null
    const error: string = 'Не удалось запустить генерацию файла'
    const res = await api.request(GET_GENERATE_FILE, {
      error,
      params: {
        reportID,
        format: fileFormat,
      },
      convertions: {
        convertParams: convertParamsGenerate,
        convertResult: convertResultGenerate,
      },
    })
    if (res) {
      return res
    }
    return error
  }, [fileFormat])

  const onFileDownload = useCallback(async (reportFileID: string) => {
    if (!reportFileID) return null
    const res = await api.download(GET_DOWNLOAD_FILE, {
      error: 'Не удалось загрузить файл',
      filename: `${filename}.${fileFormat}`,
      params: {
        reportFileID,
      },
      convertions: {
        convertParams: convertParamsDownload,
      },
    })
    return res
  }, [filename, fileFormat])

  return {
    getGenerateFile,
    onFileDownload,
  }
}
